import { render, staticRenderFns } from "./CreateRoomHighCurtain.vue?vue&type=template&id=7aab8305"
import script from "./CreateRoomHighCurtain.vue?vue&type=script&lang=js"
export * from "./CreateRoomHighCurtain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports